import { Plugin, Transformer } from 'unified'
import { Node } from 'unist'
import { is } from 'unist-util-is'
import visit, { Visitor } from 'unist-util-visit'

type BaseNode = {
  type: string
  tagName: string
  properties?: {
    className?: string[]
  }
}

type FootnoteElement = {
  type: 'element'
  tagName: 'div'
  properties: {
    className: string[]
  }
  children: (Node & BaseNode)[]
}

/** Visitor to transform matching FootnoteElement nodes */
const visitor: Visitor<FootnoteElement> = (node) => {
  // get the index of the `hr` element in the footnotes div
  const index = node.children.findIndex((child) => child.tagName === 'hr') + 1
  // insert a new Footnotes heading after the `hr`
  const children = [
    ...node.children.slice(0, index),
    {
      type: 'element',
      tagName: 'h2',
      properties: { id: 'footnotes' },
      children: [
        {
          type: 'text',
          value: 'Footnotes',
        },
      ],
    },
    ...node.children.slice(index),
  ]
  //@ts-expect-error Old code, there might an actual error here
  node.children = children
}

/** Transformer to visit any div element with className = `footnotes` */
const transformer: Transformer = (ast) => {
  visit(
    ast,
    (node: unknown): node is FootnoteElement =>
      is(node, { tagName: 'div' }) &&
      !!(node as BaseNode)?.properties?.className?.includes('footnotes'),
    visitor,
  )
}

const plugin: Plugin = () => {
  return transformer
}

export default plugin
